import { AlertUtil } from './../utils/alert-util'
import { Component, OnInit, ViewChild } from '@angular/core'
import { OverlayPanel } from 'primeng/overlaypanel'
import { IDocumento } from '../interfaces/IDocumento'
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading'
import { RequestBuilder } from '../classes/request-builder';
import { StoricoModuloService } from '../services/storicomodulo.service';
import { finalize } from 'rxjs/operators';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte';

@Component({
  selector: 'app-send-documento-modal',
  templateUrl: './send-documento-modal.component.html',
  styleUrls: ['./send-documento-modal.component.css']
})
export class SendDocumentoModalComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel
  isValid: boolean = false
  isAffidatario: boolean = false

  documento: IDocumento
  SE = Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM   //export for html
  constructor(private alertUtil: AlertUtil,
    private storicoModuloService: StoricoModuloService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig) {

    this.documento = this.config.data.documento
    this.isValid = this.documento.StatoModulo.Id == Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.APPROVATO
    this.isAffidatario = this.config.data.isAffidatario
  }

  ngOnInit() {
  }

  /**
   * Send documento to Prefettura
   */
  sendDocumentoToPrefettura() {
    this.alertUtil.showConfirmationAlert("LBL_RICHIESTA_SEND_TO_CONFIRMATION", null, null, null, null, () => {
      //set StatoModulo to APPROVATO
      this.documento.StatoModulo.Id = Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.APPROVATO
      this.documento.StatoModulo.Nome = Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.APPROVATO
      // force documento.StatoModulo.Moduli as null
      this.documento.StatoModulo.Moduli = null

      //change status documento
      Loading.isLoading = true
      let reqBuilder = new RequestBuilder({
        Id: this.documento.Id,
        StatoModulo: this.documento.StatoModulo
      })
      this.storicoModuloService.storicoChangeStatus(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            this.alertUtil.showAlert("LBL_DOCUMENTO_SENT_TO_PREFETTURA", null, null, null, () => {
              //force refresh documento table
              this.ref.close(this.documento)
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }


  /**
   * Send documento to Aggiudicatario
   * set StatoModulo to IN VARIAZIONE
   */
  sendDocumentoToAggiudicatario() {
    this.alertUtil.showConfirmationAlert("LBL_RICHIESTA_SEND_TO_CONFIRMATION", null, null, null, null, () => {

      this.changeDocumentoStatus();

      // force documento.StatoModulo.Moduli as null
      this.documento.StatoModulo.Moduli = null

      //change status documento
      Loading.isLoading = true

      let reqBuilder = new RequestBuilder({
        Id: this.documento.Id,
        StatoModulo: this.documento.StatoModulo
      })
      this.storicoModuloService.storicoChangeStatus(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            this.alertUtil.showAlert("LBL_DOCUMENTO_SENT_TO_AGGIUDICATARIO", null, null, null, () => {
              //force refresh richieste table
              this.ref.close(this.documento)
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }

  /**
   * change documento status
   * @param statoDocumento documento enum
   */
  private changeDocumentoStatus(statoDocumento?: Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM) {
    if (!statoDocumento) {
      
      //set statoDocumento
      statoDocumento = this.documento.Valido == true ? Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.APPROVATO : Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_NON_APPROVATA
    }

    if (statoDocumento == Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.APPROVATO) {
      // set statoDocumento to APPROVATO
      this.documento.StatoModulo.Id = Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.APPROVATO;
      this.documento.StatoModulo.Nome = Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.APPROVATO;
    }
    else if (statoDocumento == Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_NON_APPROVATA) {
      // set statoDocumento to VARIAZIONE_NON_APPROVATA
      this.documento.StatoModulo.Id = Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.VARIAZIONE_NON_APPROVATA;
      this.documento.StatoModulo.Nome = Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_NON_APPROVATA;
    }
    else {
      // set statoDocumento to IN_VARIAZIONE
      this.documento.StatoModulo.Id = Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.IN_VARIAZIONE;
      this.documento.StatoModulo.Nome = Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.IN_VARIAZIONE;
    }
  }

}
